// create
export const CREATE_AMEND_REQUEST = "CREATE_AMEND_REQUEST";
export const CREATE_AMEND_SUCCESS = "CREATE_AMEND_SUCCESS";
export const CREATE_AMEND_FAIL = "CREATE_AMEND_FAIL";

export const AMEND_CLEAR_ERROR = "AMEND_CLEAR_ERROR";